import { computed, queryCollection, useAsyncData } from '#imports'

export interface AuthTestimonial {
  quote: string
  name: string
  title: string
  company: string
  avatar?: string
  companyLogo?: string
}

const FALLBACK_TESTIMONIAL: AuthTestimonial = {
  quote:
    'Forgd has supported Solana’s biggest launches & empowered countless teams '
    + 'with data-driven best practices.',
  name: 'Ben Sparango',
  title: 'Head of Special Projects',
  company: 'Solana Labs',
  avatar: '/auth/testimonials/ben-sparango.svg',
  companyLogo: '/auth/testimonials/solana-labs.svg',
}

export function useAuthTestimonials() {
  const { data } = useAsyncData('auth-testimonials', async () => {
    try {
      return await queryCollection('testimonials').all()
    }
    catch {
      return []
    }
  }, { default: () => [] })

  const testimonials = computed<AuthTestimonial[]>(() => {
    const items = (data.value ?? [])
      .filter(t => t.enabled !== false)
      .sort((a, b) => (a.order ?? 0) - (b.order ?? 0))
      .map(t => ({
        quote: t.quote,
        name: t.name,
        title: t.title,
        company: t.company,
        avatar: t.avatar ?? undefined,
        companyLogo: t.companyLogo ?? undefined,
      }))

    if (items.length === 0) {
      return [FALLBACK_TESTIMONIAL]
    }

    return items
  })

  const testimonial = computed<AuthTestimonial>(() => testimonials.value[0] ?? FALLBACK_TESTIMONIAL)

  return { testimonials, testimonial }
}
